/**
 * `RowSourceContext` — exposes the active `RowSource` to SpreadsheetEditor
 * descendants (TV1-1690 / B-7).
 *
 * For ticket B-7 NO descendant reads from this context — they all keep reading
 * from Redux. The provider is in place so B-8 (held) can swap in a
 * `ServerWindowedRowSource` and have descendants opt in via `useRowSource()`
 * without restructuring the component tree.
 */
import { createContext, useContext } from 'react';
import { RowSource } from './RowSource';

const RowSourceContext = createContext<RowSource | null>( null );

export const RowSourceProvider = RowSourceContext.Provider;

export const useRowSource = (): RowSource => {
  const ctx = useContext( RowSourceContext );
  if ( !ctx ) throw new Error( 'useRowSource must be used inside <RowSourceProvider>' );
  return ctx;
};
